/*
 * Copyright (c) 2023 Anvilor Solutions LLC - All Rights Reserved.
 *
 * The information and source code contained herein is the exclusive property of
 * Anvilor Solutions LLC and may not be disclosed, examined, or reproduced in whole
 * or in part without the explicit written authorization from Anvilor Solutions LLC.
 */

import { Component, ChangeDetectionStrategy } from "@angular/core";
import { OnInit } from "@angular/core";
import { Input } from "@angular/core";
import { ViewChild } from "@angular/core";
import { RuiStore } from "@anvilor/ngx-rui";
import { RuiControlOutletDirective } from "@anvilor/ngx-rui";
import { ControlInflatorService } from "@anvilor/ngx-rui";
import { IRuiControlComponent } from "@anvilor/ngx-rui";
import { FormLayoutControl } from "./form-layout-control";
import { SubscriptionGroup } from "@anvilor/ngx-core-utils";
import { filterNullish } from "@anvilor/ngx-core-utils";
import { asSignal } from "@anvilor/ngx-core-utils";
import { Observable } from "rxjs";
import { withLatestFrom } from "rxjs";
import { tap } from "rxjs";
import { distinctUntilChanged } from "rxjs";
import { switchMap } from "rxjs/operators";
import { ThemeService } from "@anvilor/ngx-theming";
import { DefaultMediaObserver } from "@anvilor/ngx-apps-core";
import { AnvilorNotificationsService } from "@anvilor/ngx-apps-core";
import { ASSET_ANVILOR_SOLID_ICON } from "../../../config/theme-config";
import { AnvilorFormsApp } from "../../../store/anvilor-forms-app-store.service";

// FUTURE - re-write this as a compound control using the more generic
//  notifications features.

@Component({
  selector: "app-form-layout-control",
  templateUrl: "./form-layout-control.component.html",
  styleUrls: ["./form-layout-control.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FormLayoutControlComponent implements IRuiControlComponent, OnInit {
  @Input() internalId!: string;
  control!: FormLayoutControl;

  @ViewChild("body", { read: RuiControlOutletDirective })
  bodyOutlet!: RuiControlOutletDirective;

  headerLogo$?: Observable<string>;
  anvilorIconPath$: Observable<string>;

  private subscriptions?: SubscriptionGroup;

  constructor(
    private store: RuiStore,
    private theme: ThemeService,
    public media: DefaultMediaObserver,
    private notifications: AnvilorNotificationsService,
    private app: AnvilorFormsApp
  ) {
    this.subscriptions = new SubscriptionGroup();

    this.anvilorIconPath$ = theme.selectAssetPath(ASSET_ANVILOR_SOLID_ICON);
  }

  ngOnInit() {
    this.control = new FormLayoutControl(this.store, this.internalId);

    this.headerLogo$ = this.control.headerLogo$.pipe(
      filterNullish(),
      switchMap((v) => this.theme.selectAssetPath(v))
    );

    this.subscriptions?.push(
      this.app.submit
        .postStatusIs("active")
        .pipe(
          distinctUntilChanged(),
          switchMap(() => this.app.submit.postStatusIs("success").pipe(asSignal())),
          withLatestFrom(
            this.control.successMessageTitle$,
            this.control.successMessageBody$,
            this.control.disableAutomaticToasts$
          ),
          tap(([_, title, body, disableToasts]) => {
            if (!disableToasts) {
              this.notifications.toast.success(body, title);
            }
          })
        )
        .subscribe()
    );
  }
}
